<template>
  <form v-if="details" autocomplete="off" @submit.prevent="onSubmitForm">
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs"></Alert>

    <div class="b-booking-upsell mb-80">
      <Loader v-if="isLoading" display="absolute"></Loader>

      <div class="b-booking-upsell__success">
        <div class="b-booking-upsell__success-header">
          <i class="icon-check-circle"></i>
          <div class="semibold p" v-html="details.vehicleDescription"></div>
        </div>
        <button type="submit" class="btn btn-outline-danger" @click.stop>
          {{ dictionary.upsellButtonUndoText }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import Loader from './common/Loader.vue'
import Alert from './common/Alert.vue'

export default {
  components: { Loader, Alert },
  props: {
    info: {
      required: true,
      type: Object,
    },
    details: {
      required: true,
      type: Object,
    },
  },
  data() {
    return { isLoading: false, errorMsgs: [], isActive: false }
  },
  methods: {
    onSubmitForm() {
      this.isLoading = true

      const postData = {
        Token: this.info.token,
        GroupName: this.info.rollbackGroupName,
      }
      axios
        .post(this.info.endpointUpsellRollbackData, postData)
        .then((response) => {
          const { HasError, Errors, Url } = response.data

          // response has error
          if (HasError) {
            this.handleError(Errors)
            return false
          }

          window.location.assign(Url)
          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },
    handleSuccess() {
      this.isLoading = false
      this.errorMsgs = []
    },
    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
